import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const MonitorContainer = styled.div`
  padding: 20px;
  font-family: 'Courier New', monospace;
  color: #00ff00;
  background: rgba(0, 0, 0, 0.9);
  height: 100%;
  overflow-y: auto;
`;

const Header = styled.div`
  border-bottom: 1px solid #00ff00;
  padding-bottom: 10px;
  margin-bottom: 20px;
`;

const ProcessList = styled.div`
  margin-bottom: 30px;
`;

const ProcessItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px;
  margin-bottom: 5px;
  background: rgba(0, 255, 0, 0.1);
  border-radius: 4px;
`;

const SkillCategory = styled.div`
  margin-bottom: 25px;
`;

const CategoryTitle = styled.h3`
  color: #00ffff;
  margin-bottom: 15px;
  border-bottom: 1px solid #00ffff;
  padding-bottom: 5px;
`;

const SkillBar = styled.div<{ level: number }>`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const SkillName = styled.div`
  width: 200px;
  color: #cccccc;
`;

const ProgressBar = styled.div`
  flex: 1;
  height: 20px;
  background: rgba(0, 0, 0, 0.5);
  border: 1px solid #00ff00;
  border-radius: 4px;
  overflow: hidden;
  margin: 0 10px;
`;

const Progress = styled.div<{ width: number }>`
  height: 100%;
  width: ${props => props.width}%;
  background: linear-gradient(90deg, #ff0000, #ffff00, #00ff00);
  transition: width 2s ease-in-out;
`;

const SkillLevel = styled.div`
  color: #00ff00;
  font-weight: bold;
  width: 50px;
`;

const SkillsMonitor: React.FC = () => {
  const [processesLoaded, setProcessesLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setProcessesLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  

  const skillCategories = [
    {
      title: 'Programming Languages',
      skills: [
        { name: 'Python', level: 70 },
        { name: 'JavaScript', level: 85 },
        { name: 'C/C++', level: 65 },
        { name: 'Bash', level: 70 },
        { name: 'SQL', level: 65 },
      ]
    },
    {
      title: 'Cybersecurity Tools',
      skills: [
        { name: 'Kali Linux', level: 95 },
        { name: 'Burp Suite', level: 90 },
        { name: 'Metasploit', level: 80 },
        { name: 'Nmap', level: 80 },
        { name: 'Wireshark', level: 80 },
        { name: 'John the Ripper', level: 85 },
        { name: 'Hydra', level: 80 },
      ]
    },
    {
      title: 'Security Domains',
      skills: [
        { name: 'Web Exploitation', level: 90 },
        { name: 'Penetration Testing', level: 85 },
        { name: 'Digital Forensics', level: 80 },
        { name: 'Cryptography', level: 75 },
        { name: 'Network Security', level: 85 },
        { name: 'IoT Security', level: 60 },
      ]
    },
    {
      title: 'Frameworks & Technologies',
      skills: [
        { name: 'Django', level: 70 },
        { name: 'React', level: 65 },
        
        { name: 'Git/GitHub', level: 80 },
        { name: 'Linux Administration', level: 90 },
      ]
    }
  ];

  return (
    <MonitorContainer>
      <Header>
        <h2>🖥️ SKILLS MONITORING SYSTEM</h2>
        <p>Real-time skill proficiency and running security processes</p>
      </Header>

        

      {skillCategories.map((category, categoryIndex) => (
        <SkillCategory key={categoryIndex}>
          <CategoryTitle>{category.title}</CategoryTitle>
          {category.skills.map((skill, skillIndex) => (
            <SkillBar key={skillIndex} level={skill.level}>
              <SkillName>{skill.name}</SkillName>
              <ProgressBar>
                <Progress width={processesLoaded ? skill.level : 0} />
              </ProgressBar>
              <SkillLevel>{skill.level}%</SkillLevel>
            </SkillBar>
          ))}
        </SkillCategory>
      ))}
    </MonitorContainer>
  );
};

export default SkillsMonitor;
